import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { User } from '../models';


@Injectable()
export class UserService {
  private currentUserSubject = new BehaviorSubject<User>(new User());
  public currentUser = this.currentUserSubject.asObservable().distinctUntilChanged();

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(
    private apiService: ApiService,
    private http: Http,
    private jwtService: JwtService
  ) { }

  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  populate() {
    // If JWT detected, attempt to get & store user's info
    if (this.jwtService.getToken()) {
      this.currentUserSubject.next(this.jwtService.getUser());
      this.isAuthenticatedSubject.next(true);
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }

  setUser(Response: any) {
    this.jwtService.saveUser(Response[0]);
  }

  // setAuth(Response: any) {
  //   // Save JWT sent from server in localstorage
  //   this.jwtService.saveToken(Response.access_token);
  //   // Set current user data into observable
  //   this.fetchUser()
  //     .subscribe(
  //     data => {
  //       this.setUser(data);
  //       this.currentUserSubject.next(this.jwtService.getUser());
  //     },
  //     err => this.purgeAuth()
  //     );
  //   // Set isAuthenticated to true
  //   this.isAuthenticatedSubject.next(true);
  // }

  setAuth(Response: any) {
    // Save JWT sent from server in localstorage
    this.setUser(Response);
    this.currentUserSubject.next(this.jwtService.getUser());
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
  }

  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next(new User());
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
  }

  attemptAuth(type, credentials, val): Observable<User> {
    const route = (type === 'login' || type === 'sign-up') ? '/api/account/Login' : '';
    return this.apiService.postLogin(route, val)
      .map(
        data => {
        // Save JWT sent from server in localstorage
          this.jwtService.saveToken(data.access_token);
          return data;
        }
      ).catch(
        (error: any, Response) => {
          return Observable.throw(error);
        }
      );
  }
   logoutSession(): Observable<User> {
        var client_id = 'ENTigerClient'
     
       let temptoken = this.jwtService.getToken()
      return this.apiService.postLogout('/connect/revocation', '&token_type_hint='+"access_token"+
                                            '&token=' + temptoken + 
                                            '&Client_id=' + client_id + 
                                            '&Client_secret='+ 'jgd123$',
          {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'})
        .map(
          data => {
            return data;
          }
        ).catch(
          (error: any, Response) => {
            return Observable.throw(error);
          }
      );
  }

  fetchCurrentUserDetail(): Observable<User> {
    return this.apiService.get('/api/mvp/um/loggedinuser/details')
      .map(
      data => {
          // if(data==0){
            // this.purgeAuth()
          // }else{
            this.setAuth(data)
          // }
          return data;
      });
      
  }

  fetchUser(): Observable<User> {
    return this.apiService.get('/api/mvp/um/loggedinuser/details')
      .map(
      data => {
        return data;
      }
      );
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }



  changePassword(data) {
    return this.apiService.post('/api/Account/ResetPassword', data)
      .map(
      (response: Response) => {
        return response;
      }
      )
      .catch(
      (error: Response) => {
        return Observable.throw('Something went wrong');
      }
      );
  }

  forgetPassword(data) {
    return this.apiService.post('/api/Account/ForgotPassword', data)
      .map(
      (response: Response) => {
        return response;
      }
      )
      .catch(
      (error: Response) => {
        return Observable.throw(error['Errors'][0]);
      }
      );
  }
  loginSession(data) {
       return this.apiService.post('/api/mvp/add/userattendance',data)
      .map(
        data => {
          return data;
        }
      );
  }
 logoutUserSession(data) {
       return this.apiService.post('/api/mvp/edit/userattendance',data)
      .map(
        data => {
          return data;
        }
      );
  }

  
  getKey() {
    return this.apiService.get('/api/Account/GetKey')
        .map(
      data => {
        return data;
      })
      .catch(
      (error: Response) => {
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts